import React, { Fragment, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { useSelector } from "react-redux"

import { validateCartContents } from "utils"
import KcCustomerMobileModal from "./KcCustomerMobileModal"
import { Button, CartStockValidationResultModal } from "components"
import classes from "./KcPosPaymentButton.module.scss"

const KcPosPaymentButton = () => {
  const [t] = useTranslation()

  const history = useHistory()

  const order =
    useSelector(state => state.order)

  const temporaryOff =
    useSelector(state => state.systemSettings.temporaryOff)

  const [sending, setSending] = useState(false)
  const [problematicItems, setProblematicItems] = useState([])
  const [openCartValidationResultModal, setOpenCartValidationResultModal] = useState(false)
  const [openCustomerMobilePhoneModal, setOpenCustomerMobilePhoneModal] = useState(false)

  const unmount = useRef(false)

  const validateCart = async () => {
    const problematicItems =
      await validateCartContents(
        order.items,
        order.combos
      )

    if (problematicItems.length === 0) return true

    setProblematicItems(
      problematicItems
    )

    setOpenCartValidationResultModal(true)

    setSending(false)

    return false
  }

  const handleCompleteOrder = async (customerMobilePhone) => {
    setSending(true)

    try {
      const result = await validateCart()

      if (!result) return setSending(false)

      history.push(
        "/kiosk-payment",
        { customerMobilePhone }
      )
    } catch (err) {
      console.log(err)

      setSending(false)
    }
  }

  useEffect(() => {
    unmount.current = false

    return () => unmount.current = true
  }, [])

  const disabledButton =
    sending || temporaryOff

  return (
    <Fragment>
      <Button
        fullWidth
        loading={disabledButton}
        className={classes["complete"]}
        onClick={() => setOpenCustomerMobilePhoneModal(true)}
      >
        {t("پرداخت_سفارش")}
      </Button>

      <CartStockValidationResultModal
        problematicItems={problematicItems}
        openCartValidationResultModal={openCartValidationResultModal}
        setOpenCartValidationResultModal={setOpenCartValidationResultModal}
      />

      {
        openCustomerMobilePhoneModal &&
        <KcCustomerMobileModal
          openModal={openCustomerMobilePhoneModal}
          setOpenModal={setOpenCustomerMobilePhoneModal}
          onSkip={() => handleCompleteOrder("")}
          onMobilePhoneEnter={(customerMobilePhone) => handleCompleteOrder(customerMobilePhone)}
        />
      }
    </Fragment>
  )
}

export default KcPosPaymentButton